import React, { useState, useMemo } from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import { Card, Snackbar, Alert } from "@mui/material";
import HeaderLote from "./components/HeaderLote";

const Lotes = () => {
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Determinar si es admin
  const isAdmin = useMemo(() => {
    try {
      const userData = localStorage.getItem("user");
      if (!userData) return false;
      const parsed = JSON.parse(userData);
      const username = (parsed.user?.username || parsed.username || "").toLowerCase();
      return username === "admin";
    } catch {
      return false;
    }
  }, []);

  const currentUserRole = useMemo(() => {
    try {
      const userData = localStorage.getItem("user");
      if (!userData) return "Usuario";
      const parsed = JSON.parse(userData);
      return parsed.role?.name || parsed.name || "Usuario";
    } catch {
      return "Usuario";
    }
  }, []);

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleRefresh = () => {
    setRefreshFlag((prev) => !prev);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={handleCloseSnackbar}
          sx={{
            width: "100%",
            backgroundColor: snackbar.severity === "success" ? "#f0fff4" : "#fff5f5",
            color: snackbar.severity === "success" ? "#276749" : "#c53030",
            border: snackbar.severity === "success" ? "1px solid #c6f6d5" : "1px solid #fed7d7",
          }}
        >
          <MDTypography variant="body1" fontWeight="bold">
            {snackbar.severity === "success" ? "¡Éxito!" : "Error"}
          </MDTypography>
          <MDTypography variant="body2">{snackbar.message}</MDTypography>
        </Alert>
      </Snackbar>

      <HeaderLote
        refreshFlag={refreshFlag}
        currentUserRole={currentUserRole}
        isAdmin={isAdmin}
        onError={(error) => {
          if (error) {
            setSnackbar({
              open: true,
              message: error,
              severity: "error",
            });
          }
        }}
        onSuccess={(message) => {
          setSnackbar({
            open: true,
            message: message || "Operación completada exitosamente",
            severity: "success",
          });
          handleRefresh();
        }}
      />
    </DashboardLayout>
  );
};

export default Lotes;
